import React from 'react';
import { Link } from 'react-router-dom';

/** Get Started onboarding checklist */
const STEPS = [
  { id: 'profile', label: 'Set up hospital profile', path: '/hms/settings', check: (h) => !!(h?.name && h?.phone) },
  { id: 'staff', label: 'Add doctors & staff', path: '/manager/admin', check: (_, d) => (d?.doctors?.length || 0) > 0 },
  { id: 'rx', label: 'Configure Rx pad & services', path: '/hms/rx-settings', check: (_, __, s) => (s?.services?.length || 0) > 0 },
  { id: 'queue', label: 'Open Q Page for first patient', path: '/reception/queue', check: () => false },
  { id: 'abha', label: 'ABHA / ABDM readiness', path: '/hms/abha', check: () => false },
  { id: 'growth', label: 'Clinic QR & Google reviews', path: '/hms/clinic-growth', check: (h) => !!(h?.googleReviewUrl || h?.clinicBookingUrl) },
];

export default function GetStartedChecklist({ hospital, directory, emrSettings, compact = false }) {
  const done = STEPS.filter((s) => s.check(hospital, directory, emrSettings)).length;
  const pct = Math.round((done / STEPS.length) * 100);

  if (pct === 100 && compact) return null;

  return (
    <div className={`card get-started${compact ? ' compact' : ''}`} style={{ borderLeft: '4px solid #0d6e6a' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: compact ? 8 : 12 }}>
        <h3 style={{ margin: 0, color: '#0d6e6a' }}>Get Started</h3>
        <span className="hint">{done}/{STEPS.length} · {pct}%</span>
      </div>
      <div className="get-started-bar" style={{ height: 6, background: '#e2e8f0', borderRadius: 4, marginBottom: 12, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: '#0d6e6a', transition: 'width 0.3s' }} />
      </div>
      <ul className="get-started-list" style={{ listStyle: 'none', margin: 0, padding: 0 }}>
        {STEPS.map((s) => {
          const ok = s.check(hospital, directory, emrSettings);
          return (
            <li key={s.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', fontSize: compact ? 13 : 14 }}>
              <span style={{ color: ok ? '#10b981' : '#94a3b8' }}>{ok ? '✓' : '○'}</span>
              {ok ? <span style={{ color: '#64748b', textDecoration: 'line-through' }}>{s.label}</span> : (
                <Link to={s.path} style={{ color: '#0d6e6a', fontWeight: 600 }}>{s.label}</Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
